import { defineMessages } from 'react-intl'

const scope = `procurify.platform.integrations.pages`

export default defineMessages({
  settingsTitle: {
    id: `${scope}.settingsTitle`,
    defaultMessage: 'Settings',
  },
  integrationListTitle: {
    id: `${scope}.integrationListTitle`,
    defaultMessage: 'Integrations',
  },
  loading: {
    id: `${scope}.loading`,
    defaultMessage: 'Loading...',
  },
  error: {
    id: `${scope}.error`,
    defaultMessage: 'Error',
  },
  notFound: {
    id: `${scope}.notFound`,
    defaultMessage: 'Integration not found.',
  },
  setupPageTitle: {
    id: `${scope}.setupPageTitle`,
    defaultMessage: '{integrationLabel} setup',
  },
  integrationNotFoundHeader: {
    id: `${scope}.integrationNotFoundHeader`,
    defaultMessage: 'Integration details unavailable',
  },
  integrationNotFoundButtonText: {
    id: `${scope}.integrationNotFoundButtonText`,
    defaultMessage: 'Back to integrations',
  },
})
